import React, { useEffect, useState } from 'react';
import { Button, Input, Select } from 'antd';
import { useSearchParams } from 'react-router-dom';

const advancedSearchOptions = [
  { label: 'Case Name', value: 'caseName' },
  { label: 'Applicant Name', value: 'applicantName' },
  { label: 'Last Activity', value: 'lastActivity/activity' }
];

interface CaseAdvanceSearchProps {
  onClose: (value: boolean) => void;
}

export const CaseAdvanceSearch: React.FC<CaseAdvanceSearchProps> = (props) => {
  const [selectedOptions, setSelectedOptions] = useState(['caseName', '', '']);
  const [inputValues, setInputValues] = useState(['', '', '']);
  const [operators, setOperators] = useState(['AND', 'AND']);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const urlOptions = searchParams.getAll('filter');
    const urlValues = searchParams.getAll('value');
    const urlOperators = searchParams.getAll('operator');

    if (urlOptions.length > 0) setSelectedOptions(urlOptions);
    if (urlValues.length > 0) setInputValues(urlValues);
    if (urlOperators.length > 0) setOperators(urlOperators);
  }, [searchParams, props]);

  const handleOptionChange = (index: any, value: any) => {
    const updatedOptions = [...selectedOptions];
    updatedOptions[index] = value;
    setSelectedOptions(updatedOptions);
  };

  const handleInputChange = (index: any, value: any) => {
    const updatedValues = [...inputValues];
    updatedValues[index] = value;
    setInputValues(updatedValues);
  };

  const handleOperatorChange = (index: any, value: any) => {
    const updatedOperators = [...operators];
    updatedOperators[index] = value;
    setOperators(updatedOperators);
  };

  const getFilteredOptions = (index: any) => {
    return advancedSearchOptions.filter((option) => !selectedOptions.includes(option.value) || option.value === selectedOptions[index]);
  };

  const handleSearch = () => {
    const params = new URLSearchParams();
    selectedOptions.forEach((option, index) => {
      if (option && inputValues[index]) {
        params.append('filter', option);
        params.append('value', inputValues[index]);
        if (index < operators.length) params.append('operator', operators[index]);
      }
    });
    params.append('advanceSearch', 'true');
    params.delete('search');
    setSearchParams(params);
  };

  const handleClose = () => {
    props.onClose(false);
  };

  const handleClear = () => {
    setSelectedOptions(['caseName', '', '']);
    setInputValues(['', '', '']);
    setOperators(['AND', 'AND']);
    const params = new URLSearchParams();
    params.append('advanceSearch', 'true');
    params.delete('search');
    setSearchParams(params);
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <div className="w-full">
          <div>
            <h2>Advanced Search</h2>
          </div>
          <div>
            {[0, 1, 2].map((index) => (
              <div key={index} className="flex flex-row items-center w-full gap-2.5 mb-2">
                <Select
                  allowClear
                  value={selectedOptions[index] || undefined}
                  onChange={(value) => handleOptionChange(index, value)}
                  style={{ width: 160 }}
                  placeholder="Select Filter"
                >
                  {getFilteredOptions(index).map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>

                <Input
                  maxLength={200}
                  value={inputValues[index]}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  style={{ width: '300px' }}
                  disabled={!selectedOptions[index]}
                />

                {index < 2 && (
                  <Select value={operators[index]} onChange={(value) => handleOperatorChange(index, value)} style={{ width: 80 }} disabled={!selectedOptions[index]}>
                    <Select.Option value="AND">AND</Select.Option>
                    <Select.Option value="OR">OR</Select.Option>
                  </Select>
                )}
              </div>
            ))}
          </div>
          <div className="my-6">
            <Button type="primary" onClick={handleSearch}>
              Search
            </Button>
            <Button onClick={handleClose} className="ml-5">
              Close
            </Button>
            <Button onClick={handleClear} className="ml-5">
              Clear</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
